import { Component, inject, Input, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat/chat.service';
import { AuthService } from '../../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-chat',
	standalone: true,
	imports: [CommonModule, PipesModule, MatIconModule],
	templateUrl: './chat.component.html',
	styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit {
	@Input() smallScreen: boolean = false;

	constructor(private chatService: ChatService) { }
	private authService = inject(AuthService);

	loggedUser: boolean = false;
	chatValidationKey: string = '';
	user = this.authService.auth?.user;

	ngOnInit(): void {
		this.loggedUser = this.authService.isUserLogged();
	}

	async startChat() {
		if (this.loggedUser) {
			this.chatService.load();
			this.chatValidationKey = await this.chatService.getChatValidationKey(this.authService.auth.user?.email);
			this.chatService.setUser(this.user?.id, this.user?.username, { client: this.user?.client, firstName: this.user?.name, lastName: this.user?.lastName }, this.chatValidationKey);
		} else {
			this.chatService.load();
		}
	}
}
